import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import { inputStyles } from 'assets/components/inputs/Input';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import RichTextInput from 'assets/components/inputs/richTextInput/RichTextInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import CheckWrapper from 'assets/components/inputs/wrappers/CheckWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import Modal from 'assets/components/page/templates/Modal';
import ThemeModalDefault from 'assets/components/page/templates/themes/Theme.Modal.Default';
import { getLocales } from 'assets/locales/Locale';
import ClaimEmailTemplateTags from 'module/management/components/claimEmailTemplate/ClaimEmailTemplateTags';
import { useClaimEdit } from '../../ClaimEdit.Hooks';

export default function ClaimEditEmailTemplate() {
  const { lang } = getLocales();
  const { changeStatusForm, setEmailAction } = useClaimEdit();

  function updateEmailTemplate(updatedEmailTemplate: Partial<Model.IClaimEmailTemplate>) {
    changeStatusForm.merge({ emailTemplate: updatedEmailTemplate });
  }
  function handleChangeStatus({ emailTemplate }: { emailTemplate: Model.IClaimEmailTemplate }) {
    changeStatusForm.update({ emailTemplate });
    setEmailAction(null);
    changeStatusForm.submit();
  }

  return (
    <Modal
      subcomponents={ThemeModalDefault}
      header={lang.emailTemplate}
      onClose={() => changeStatusForm.update({ emailTemplate: null })}
      render={
        <FormWrapper>
          <TextInput
            name="name"
            label={lang.name}
            value={changeStatusForm.data.emailTemplate.name}
            error={changeStatusForm.errors.emailTemplate?.name}
            onChange={updateEmailTemplate}
            icon={<Icon class="if-quill-pen" />}
          />
          <InputWrapper>
            <TextInput
              name="senderName"
              label={lang.senderName}
              value={changeStatusForm.data.emailTemplate.senderName}
              error={changeStatusForm.errors.emailTemplate?.senderName}
              onChange={updateEmailTemplate}
              icon={<Icon class="if-quill-pen" />}
            />
            <TextInput
              name="senderEmail"
              label={lang.senderEmail}
              value={changeStatusForm.data.emailTemplate.senderEmail}
              error={changeStatusForm.errors.emailTemplate?.senderEmail}
              onChange={updateEmailTemplate}
              icon={<Icon class="if-quill-pen" />}
            />
          </InputWrapper>
          <h2>{lang.sendTo}</h2>
          <CheckWrapper>
            <CheckInput
              name="sendToClient"
              label={lang.client}
              class={inputStyles.check.switch}
              value={changeStatusForm.data.emailTemplate?.sendToClient}
              onChange={updateEmailTemplate}
              htmlElementProps={{
                title: changeStatusForm.data.emailTemplate?.sendToClient ? lang.disable : lang.enable,
              }}
            />
            <CheckInput
              name="sendToContactEmail"
              label={lang.contact}
              class={inputStyles.check.switch}
              value={changeStatusForm.data.emailTemplate?.sendToContactEmail}
              onChange={updateEmailTemplate}
              htmlElementProps={{
                title: changeStatusForm.data.emailTemplate?.sendToContactEmail ? lang.disable : lang.enable,
              }}
            />
            <CheckInput
              name="sendToClaimOwner"
              label={lang.claimOwner}
              class={inputStyles.check.switch}
              value={changeStatusForm.data.emailTemplate?.sendToClaimOwner}
              onChange={updateEmailTemplate}
              htmlElementProps={{
                title: changeStatusForm.data.emailTemplate?.sendToClaimOwner ? lang.disable : lang.enable,
              }}
            />
          </CheckWrapper>
          <h2>{lang.additionalRecipientEmails}</h2>
          <DataMap
            data={[...(changeStatusForm.data.emailTemplate?.additionalRecipientEmails || []), '']}
            render={({ data: email, index }) => (
              <TextInput
                key={index}
                name="email"
                label={lang.email}
                value={email}
                error={changeStatusForm.errors.emailTemplate?.additionalRecipientEmails}
                onChange={({ email }) => {
                  let additionalRecipientEmails = changeStatusForm.data.emailTemplate?.additionalRecipientEmails || [];
                  additionalRecipientEmails.splice(index, 1, email);
                  additionalRecipientEmails = additionalRecipientEmails.filter((it) => it);
                  changeStatusForm.update({
                    emailTemplate: { ...changeStatusForm.data.emailTemplate, additionalRecipientEmails },
                  });
                }}
                icon={<Icon class="if-quill-pen" />}
              />
            )}
          />
          <h2>{lang.email}</h2>
          <TextInput
            name="subject"
            label={lang.subject}
            value={changeStatusForm.data.emailTemplate.subject}
            error={changeStatusForm.errors.emailTemplate?.subject}
            onChange={updateEmailTemplate}
            icon={<Icon class="if-quill-pen" />}
          />
          <RichTextInput
            name="htmlBody"
            label={lang.htmlBody}
            value={changeStatusForm.data.emailTemplate.htmlBody}
            error={changeStatusForm.errors.emailTemplate?.htmlBody}
            onChange={updateEmailTemplate}
            icon={<Icon class="if-quill-pen" />}
            customActions={<ClaimEmailTemplateTags />}
          />
        </FormWrapper>
      }
      footer={
        <>
          <Button
            onClick={handleChangeStatus}
            data={{ emailTemplate: null }}
            media="fas-ban"
            render={lang.changeStatusAndDontSendEmail}
            class={ThemeButtonCircle}
            disabled={changeStatusForm.isSubmitted || changeStatusForm.hasErrors}
          />
          <Button
            onClick={handleChangeStatus}
            data={{
              emailTemplate: changeStatusForm.data?.emailTemplate,
            }}
            disabled={changeStatusForm.isSubmitted || changeStatusForm.hasErrors}
            media="fas-save"
            render={lang.changeStatusAndSendEmail}
            class={ThemeButtonCircle}
            active
          />
        </>
      }
    />
  );
}
